import t from "./ghl-ui.es1550.js";
function e(a) {
  return t(this, a).has(a);
}
export {
  e as default
};
